'use strict';

import 'nls!./languages.json';

const searchLanguages = [
  'english',
  'spanish',
  'german',
  'french',
  'italian',
  'chinese',
];

const popularLanguages = [
  'arabic',
  'chinese',
  'english',
  'french',
  'german',
  'italian',
  'japanese',
  'portuguese',
  'russian',
  'spanish'
];
const languages = [
  'arabic',
  'danish',
  'german',
  'belorussian',
  'dutch',
  'greek',
  'japanese',
  'portuguese',
  'italian',
  'polish',
  'spanish',
  'swedish',
  'bulgarian',
  'english',
  'hebrew',
  'korean',
  'romanian',
  'thai',
  'catalan',
  'estonian',
  'hindi',
  'latvian',
  'russian',
  'turkish',
  'chinese',
  'filipino',
  'hungarian',
  'lithuanian',
  'serbian',
  'ukrainian',
  'croatian',
  'finnish',
  'icelandic',
  'norwegian',
  'slovak',
  'urdu',
  'czech',
  'french',
  'indonesian',
  'persian',
  'slovenian',
  'vietnamese',
  'nepali',
  'armenian',
  'kurdish',
  'bengali',
  'georgian',
  'afrikaans',
  'luxembourgish',
  'punjabi',
  'sign',
  'azerbaijani',
  'basque',
  'bosnian'
].sort();
var languageObject = languages.reduce(function (languages, language) {
  languages[language] = {
    value: language,
    translationKey: 'LANGUAGES.' + language.toUpperCase(),
    popular: (popularLanguages.indexOf(language) !== -1),
  };
  return languages;
}, {});

var searchLanguageObject = languages.reduce(function (searchLanguages, language) {
  searchLanguages[language] = {
    value: language,
    translationKey: 'LANGUAGES.' + language.toUpperCase(),
  };
  return searchLanguages;
}, {});

export default {
  options: languages.map(function (language) {
    return languageObject[language];
  }),
  all: languageObject,
  search: searchLanguages.map(function (language) {
    return searchLanguageObject[language];
  }),
};



// WEBPACK FOOTER //
// ./app/src/constants/languages.js